<template>
    <div>
        <div class="header">
            <h4>Experiments</h4>
            <div class="buttons">
                <el-button type="primary" @click="newItem" size="mini" icon="el-icon-plus" round>New</el-button>
                <el-button @click="showResults" size="mini" icon="el-icon-data-line" round>Results on Mixpanel</el-button>
                <el-tooltip placement="top" content="Refreshes the mapping between experiments and cohort users">
                    <el-button @click="refreshExperimentsCohorts" size="mini" icon="el-icon-refresh" round :loading="loading.experimentCohortsRefresh">
                        Refresh Experiments/Cohorts mapping
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <Table :items="experiments" :columns="columns" :actions="actions" filterProp="name" :loading="loading.experiments" />

        <EditDialog :item="item" :isOpen="showEditDialog" :onClose="() => showEditDialog = false" />
    </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Table from '@/components/Table';
import EditDialog from './ExperimentsDialog';
import { defaultExperimentItem, experimentColumns } from '../constants';

export default {
    name: 'experiments',
    data() {
        return {
            columns: experimentColumns,
            actions: [
                { name: 'Edit', type: 'default', onClick: this.edit },
                { name: 'Start', type: 'primary', onClick: this.deploy },
                { name: 'Stop', type: 'danger', onClick: this.endExperiment, requiresConfirm: true },
                { name: 'Refresh cohort', type: 'default', onClick: this.refresh },
                { name: 'Archive', type: 'warning', onClick: this.archive, requiresConfirm: true },
            ],
            mixpanelUrl: 'https://mixpanel.com/report/1045685/view/860923/experiment-reporting',

            item: {},
            showEditDialog: false,
        };
    },
    mounted() {
        this.getCohorts();
        this.getExperiments();
    },
    components: {
        Table,
        EditDialog,
    },
    computed: mapGetters(['experiments', 'loading']),
    methods: {
        ...mapMutations(['setLoading', 'unsetLoading']),
        ...mapActions(['getExperiments', 'getCohorts', 'refreshExperimentsCohorts']),
        newItem() {
            this.item = cloneDeep(defaultExperimentItem);
            this.showEditDialog = true;
        },
        showResults() {
            window.open(this.mixpanelUrl, '_blank');
        },
        edit(experiment) {
            this.item = cloneDeep(experiment);
            this.showEditDialog = true;
        },
        async refresh(experiment) {
            const { cohort_id: cohortId } = experiment;
            this.setLoading('experimentCohortsRefresh');
            if (!cohortId) {
                this.$notify.error({ title: "This experiment does not have a cohort." });
            } else {
                try {
                    await this.$api.post(`/product/experiments/refresh_cohort/${cohortId}`);
                    this.$notify.success({ title: `${cohortId} is beign refreshed!` });
                } catch (e) {
                    this.$notify.error({
                        title: 'Refresh failed.',
                        message: e.message,
                    });
                }
            }
            this.unsetLoading('experimentCohortsRefresh');
        },
        async deploy(experiment) {
            try {
                await this.$api.post(`/product/experiments/${experiment.id}/deploy`);
                this.$notify.success({ title: `${experiment.name} is now active!` });
                this.getExperiments();
            } catch (e) {
                this.$notify.error({
                    title: 'Deploy failed.',
                    message: e.message,
                });
            }
        },
        async endExperiment(experiment) {
            try {
                await this.$api.delete(`/product/experiments/${experiment.id}`);
                this.$message.info(`${experiment.name} has now ended.`);
                this.getExperiments();
            } catch (e) {
                this.$notify.error({
                    title: 'Coludn\'t end experiment :(',
                    message: e.message,
                });
            }
        },
        async archive(experiment) {
            if (experiment.is_active) {
              this.$message.info(`You can't archive an active experiment, end it first!`);
              return;
            }
            if (experiment.is_archived) {
              this.$message.info(`You can't archive an already archived experiment!`);
              return;
            }
            try {
                await this.$api.post(`/product/experiments/${experiment.id}/archive`);
                this.$message.info(`${experiment.name} was archived.`);
                this.getExperiments();
            } catch (e) {
                this.$notify.error({
                    title: 'Coludn\'t archive the experiment :(',
                    message: e.message,
                });
            }
        }
    }
}
</script>

<style scoped>
.header {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 10px 0;
}

.between-label {
    margin: 0 8px;
}

.buttons {
    display: flex;
    align-items: center;
}

.buttons > * {
    margin-right: 5px;
}

h4 {
    margin-right: 10px;
}
</style>
